import { getConfig } from '~/org/twilio/one-support-center/shared/osc-env';

import { constants, types } from './definitions';
import {
  getTwilioHost,
  getTwilioProtocol,
  getRealm,
  types as envTypes,
} from '~/org/twilio/one-support-center/shared/osc-env';
import logger from './../../lib/logger';

const { hostName } = getConfig();

export const twilioProtocol = getTwilioProtocol(
  window.location.hostname as envTypes.Hostname,
);
export const twilioHost = getTwilioHost(
  window.location.hostname as envTypes.Hostname,
);
export const twilioRealm =
  getRealm(window.location.hostname as envTypes.Hostname) || 'prod';

export const gitSha = process.env.NX_GIT_SHA;

export const signUpUrl = `${twilioProtocol}${twilioHost}/try-twilio`;

export const loginUrl = `${twilioProtocol}${twilioHost}/login`;

export const logoutUrl = `${twilioProtocol}${twilioHost}/logout`;

export const consoleUrl = `${twilioProtocol}${twilioHost.replace(
  /www/,
  'console',
)}`;

const consoleNavigationRpc = `${twilioProtocol}${twilioHost}/console/api/navigation/rpc`;

/**
 * Temporary duplication of deepLink from console utility for directing redirecting
 * users from OSC to Console - Support pages. Can be deprecated once all functionality
 * is migated to OSC
 */
export const deeplink = async (
  authFlowPath: `/${string}`,
  deeplinkPath: string,
): Promise<void> => {
  const authFlowUrl = new URL(authFlowPath, `${twilioProtocol}${twilioHost}`);
  const fetchDeeplinkUrl = `${consoleNavigationRpc}/public?name=deeplinkToken&args=%7B"url"%3A"${deeplinkPath}"%7D`;

  try {
    const fetchDeeplinkQuery = await fetch(fetchDeeplinkUrl, {
      credentials: 'include',
    });

    if (fetchDeeplinkQuery?.ok && fetchDeeplinkQuery?.status === 200) {
      const { result } = await fetchDeeplinkQuery.json();
      authFlowUrl.search = result?.queryString;
    }
  } catch (err) {
    logger.error(`${constants.logPrefixes.domain}::[deeplink]`, { error: err });
  }

  return window.location.assign(authFlowUrl.toString());
};

export const loginRedirectToConsole = async (
  supportPath: types.LegacySupportPaths,
): Promise<void> => {
  const consoleNavigationUrl =
    constants.supportPathToConsoleUrlMap[supportPath];
  const deeplinkPath = `${constants.CONSOLE_ZEN_REDIRECT_ROOT_PATH}/${consoleUrl}${consoleNavigationUrl}?frameUrl=${supportPath}`;

  await deeplink(`/login`, deeplinkPath);
};

export const loginRedirectToOsc = async (path?: string): Promise<void> => {
  // Currently passing 'help.<env>.twilio.com'
  // Would ideally also pass routes such as:
  // - /submit
  // - /tickets + /tickets/:id
  // - etc.

  const deeplinkPath = path ? `${hostName}${path}` : hostName;

  await deeplink('/login', deeplinkPath);
};
